import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUiStore = defineStore('ui', () => {
  // Snackbar
  const snackbarVisible = ref(false)
  const snackbarMessage = ref('')
  const snackbarColor = ref('info')

  function showSnackbar(msg, type = 'info') {
    snackbarMessage.value = msg
    snackbarColor.value = type
    snackbarVisible.value = true
  }

  const showSuccessMessage = msg => showSnackbar(msg, 'success')
  const showErrorMessage   = msg => showSnackbar(msg, 'error')
  const showWarningMessage = msg => showSnackbar(msg, 'warning')
  const showInfoMessage    = msg => showSnackbar(msg, 'info')

  // Alert/Modal
  const alertVisible = ref(false)
  const alertMessage = ref('')
  const alertType = ref('info')

  function showAlert(msg, type = 'info') {
    alertMessage.value = msg
    alertType.value = type
    alertVisible.value = true
  }

  const showSuccessAlert = msg => showAlert(msg, 'success')
  const showErrorAlert   = msg => showAlert(msg, 'error')
  const showWarningAlert = msg => showAlert(msg, 'warning')
  const showInfoAlert    = msg => showAlert(msg, 'info')

  return {
    snackbarVisible,
    snackbarMessage,
    snackbarColor,
    alertVisible,
    alertMessage,
    alertType,
    showSuccessMessage,
    showErrorMessage,
    showWarningMessage,
    showInfoMessage,
    showSuccessAlert,
    showErrorAlert,
    showWarningAlert,
    showInfoAlert,
  }
})
